import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const store = { name : 'Calendar for On Golf',
                email : 'xyz@web.de',
                on : false};
ReactDOM.render(<App {...store} />, document.getElementById('root')); 
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js